import React from "react";

// Money envelope: an envelope pocket with a dollar banknote peeking out the top.
// Accepts Phosphor-like props (size, className); ignores `weight`.
export function MoneyEnvelope({ size = 24, className = "", weight, ...rest }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor"
      strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={className} {...rest}>
      <rect x="7" y="2.5" width="10" height="8" rx="1.2" />
      <path d="M12 4.3v4.4" />
      <path d="M13.5 5.2c-.45-.5-1.05-.7-1.65-.7-.95 0-1.6.5-1.6 1.15 0 1.45 3.3.65 3.3 2.2 0 .7-.7 1.2-1.7 1.2-.7 0-1.35-.28-1.75-.78" />
      <path d="M3.75 10.5h16.5v8.25a1.25 1.25 0 0 1-1.25 1.25H5A1.25 1.25 0 0 1 3.75 18.75z" />
      <path d="M3.75 10.5 12 16l8.25-5.5" />
    </svg>
  );
}
